import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3997a267"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toolbar" }
const _hoisted_2 = { class: "row items-center q-gutter-md" }
const _hoisted_3 = { class: "col" }

import DisplayProperty from 'components/global-common/DisplayProperty.vue';
import ToggleButtonGroup from 'components/global-common/ToggleButtonGroup.vue';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'GrouperHeader',
  setup(__props) {

const model = ref(null);

let options = [];

return (_ctx: any,_cache: any) => {
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!

  return (_openBlock(), _createBlock(_component_q_toolbar, { class: "grouper-header" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_q_toolbar_title, { class: "gt-sm title" }, {
            default: _withCtx(() => [
              _createTextVNode(" Bailey, James ")
            ]),
            _: 1
          }),
          _createVNode(_component_q_select, {
            outlined: "",
            dense: "",
            modelValue: model.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
            options: _unref(options),
            label: "Sex",
            class: "sex"
          }, null, 8, ["modelValue", "options"]),
          _createVNode(_component_q_select, {
            outlined: "",
            dense: "",
            modelValue: model.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model).value = $event)),
            options: _unref(options),
            label: "Discharge Status",
            class: "discharge-status"
          }, null, 8, ["modelValue", "options"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(DisplayProperty, {
              label: "Discharge Date",
              value: "03/12/2023"
            })
          ]),
          _createVNode(ToggleButtonGroup, { class: "gt-sm" })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})